import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { NOTIFICATION_ID } from "../../constants/Notification";
import UserType from "../../constants/UserType";
import { sendNotificationRequest } from "../../firebase/notification";
import { updateFirstTimeLoginPopup } from "../../firebase/popup";
import { RootState } from "../../redux/store";
import Button from "../Button";
import PopupComponent from "../PopupComponent";

const body = {
  [UserType.Chef]: `🌿 Welcome to More Pleaze, where health and wellness meet delightful dining experiences! Complete your profile to connect with our talented clients and embark on a culinary journey that nourishes your body and soul. Let's create a vibrant and delicious world together! 🥦🍓✨`,
  [UserType.Client]: `🌿 Welcome to More Pleaze, where health and wellness meet delightful dining experiences! Complete your profile to connect with our talented chefs and embark on a culinary journey that nourishes your body and soul. Let's create a vibrant and delicious world together! 🥦🍓✨`,
};

const FirstTimeLoginPopup = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const [open, setOpen] = useState<boolean>(false);
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (
      user &&
      user.uid &&
      user.noOfTimeLogin &&
      user.noOfTimeLogin === 1 &&
      !user.firstTimeLoginPopup
    ) {
      setOpen(true);
      updateFirstTimeLoginPopup(user.uid);
    } else if (!user.uid) {
      handleClose();
      setEmailSent(false); // Reset email sent state when user logs out
    }
  }, [user]);

  useEffect(() => {
    if (user.uid && open && !emailSent) {
      sendNotificationRequest(
        user.uid,
        user.userType === UserType.Client
          ? NOTIFICATION_ID.OB5L
          : NOTIFICATION_ID.OB5H,
        user.userType === UserType.Client
          ? [
              {
                key: "clientName",
                value: user.firstName || "",
              },
            ]
          : [
              {
                key: "chefName",
                value: user.firstName || "Chef",
              },
            ]
      );
      setEmailSent(true);
    }
  }, [open, user.uid, user.userType, user.firstName, emailSent]);

  // Create metadata for the popup display
  const popupMetaData = [
    {
      key: "chefName" as const,
      value: user.firstName + " " + user.lastName,
    },
  ];

  return (
    <PopupComponent
      sx={{ zIndex: 1500 }}
      button2Function={handleClose}
      button1Function={handleClose}
      notificationId={
        user.userType === UserType.Client
          ? NOTIFICATION_ID.PU1L
          : NOTIFICATION_ID.PU1H
      }
      metaData={popupMetaData} // Pass the metadata to populate dynamic variables
      user={user}
      open={open}
      handleClose={handleClose}
    />
  );
};

export default FirstTimeLoginPopup;
